import { z } from "zod";
//#region src/wildcard-tls-secret.schemas.ts
/**
* Zod schemas for the wildcard-tls pull-based secret delivery path.
*
* Used by:
*   - CP release-engine: validates the desired-state `secrets` block it
*     emits and the `WildcardTlsSecretResponse` body it serves.
*   - DP operator: validates the response body received from
*     `GET /v1/data-planes/:dpId/secrets/wildcard-tls` before rewriting
*     the local `wildcard-tls` Secret.
*/
/** Lowercase hex SHA-256 digest (64 chars). */
const Sha256HexSchema = z.string().regex(/^[0-9a-f]{64}$/, "expected lowercase hex SHA-256");
/** Non-empty base64 — just enforces non-empty + base64 alphabet. */
const Base64Schema = z.string().min(1).regex(/^[A-Za-z0-9+/=\r\n]+$/, "expected base64-encoded string");
/** Metadata for a pull-based secret advertised in desired-state. */
const PullSecretRefSchema = z.object({
	hash: Sha256HexSchema,
	version: z.string().min(1)
}).strict();
/** `secrets` block of the desired-state envelope. */
const SecretsBlockSchema = z.object({ wildcardTls: PullSecretRefSchema.optional() }).strict();
/** `GET /v1/data-planes/:dpId/secrets/wildcard-tls` response body. */
const WildcardTlsSecretResponseSchema = z.object({
	hash: Sha256HexSchema,
	version: z.string().min(1),
	tlsCrt: Base64Schema,
	tlsKey: Base64Schema
}).strict();
//#endregion
export { PullSecretRefSchema, SecretsBlockSchema, WildcardTlsSecretResponseSchema };

//# sourceMappingURL=wildcard-tls-secret.schemas.js.map